import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { useSettings } from "../context/SettingsContext";
import { fileUrl } from "../lib/api";
import { ShoppingCart, Menu, X, Leaf, Lock } from "lucide-react";
import { Button } from "./ui/button";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/catalogo", label: "Catalogo" },
  { to: "/chi-siamo", label: "Chi siamo" },
  { to: "/herbalife-rossano", label: "Herbalife Rossano" },
  { to: "/faq", label: "FAQ" },
  { to: "/contatta-il-distributore", label: "Contatti" },
];

export function Navbar() {
  const { count } = useCart();
  const { settings } = useSettings();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const logo = fileUrl(settings?.logo_url);

  const linkClass = ({ isActive }) => `text-sm font-semibold transition-colors ${isActive ? "text-primary" : "text-slate-700 hover:text-primary"}`;

  return (
    <header className="sticky top-0 z-40 glass border-b border-slate-200/60">
      <nav className="mx-auto max-w-7xl px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
        <Link to="/" className="flex items-center gap-2 text-primary font-display font-extrabold text-lg shrink-0" data-testid="nav-logo">
          {logo ? <img src={logo} alt={settings?.shop_name} className="h-9 w-auto" /> : <><Leaf className="w-6 h-6" /> {settings?.shop_name || "Herbalife Shop"}</>}
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {NAV.map((n) => <NavLink key={n.to} to={n.to} className={linkClass} data-testid={`nav-${n.label.toLowerCase()}`} end={n.to === "/"}>{n.label}</NavLink>)}
        </div>

        <div className="flex items-center gap-1 sm:gap-2">
          <Link to="/admin/login" title="Area riservata" className="hidden sm:flex items-center gap-1.5 px-3 py-2 rounded-full text-slate-500 hover:text-primary hover:bg-emerald-50 transition-colors" data-testid="nav-admin">
            <Lock className="w-4 h-4" />
            <span className="text-sm font-medium">Area riservata</span>
          </Link>
          <Link to="/carrello" className="relative p-2 text-slate-800 hover:text-primary" data-testid="nav-cart">
            <ShoppingCart className="w-6 h-6" />
            {count > 0 && <span className="absolute -top-0.5 -right-0.5 bg-accent text-white text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center" data-testid="cart-count">{count}</span>}
          </Link>
          <button className="md:hidden p-2 text-slate-800" onClick={() => setOpen(!open)} data-testid="nav-toggle">{open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}</button>
        </div>
      </nav>
      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white px-6 py-3 space-y-1">
          {NAV.map((n) => <NavLink key={n.to} to={n.to} end={n.to === "/"} onClick={() => setOpen(false)} className="block py-2.5 font-semibold text-slate-700" data-testid={`mnav-${n.label.toLowerCase()}`}>{n.label}</NavLink>)}
          <Link to="/admin/login" onClick={() => setOpen(false)} className="flex items-center gap-2 py-2.5 font-semibold text-slate-500 border-t border-slate-100 mt-1 pt-3" data-testid="mnav-admin"><Lock className="w-4 h-4" /> Area riservata</Link>
        </div>
      )}
    </header>
  );
}
